module.exports = __webpack_public_path__ + "static/pronto-atendimento-internacao-b-1eae350f41a84c8f6fa40f6d7a78e212.jpg";